import React, { useState } from 'react';
import { Button } from '../../components/UI';
import { linesToList, listToLines } from './marketingFormat';
import styles from './Marketing.module.css';

const EditPanel = ({ fields, draft, busy, onSave, onCancel }) => {
  const [values, setValues] = useState(() => Object.fromEntries(
    fields.map((f) => [f.key, f.list ? listToLines(draft[f.key]) : String(draft[f.key] ?? '')]),
  ));
  // onSave(changed) is awaited by the card, which closes the panel only once
  // the save succeeded; on failure the panel (and the admin's edits) stays.
  // Nothing changed → nothing to save: just close (the backend would reject
  // an empty edit anyway).
  const save = () => {
    const changed = {};
    for (const f of fields) {
      const v = f.list ? linesToList(values[f.key]) : values[f.key];
      const before = f.list ? linesToList(listToLines(draft[f.key])) : String(draft[f.key] ?? '');
      if (JSON.stringify(v) !== JSON.stringify(before)) changed[f.key] = v;
    }
    if (Object.keys(changed).length === 0) {
      onCancel();
      return;
    }
    onSave(changed);
  };
  return (
    <div className={styles.editPanel}>
      {fields.map((f) => (
        <label key={f.key} className={styles.editField}>
          <span className={styles.fieldLabel}>{f.label}{f.list ? ' (one per line)' : ''}</span>
          {f.multiline || f.list ? (
            <textarea rows={f.list ? 4 : 8} value={values[f.key]} onChange={(e) => setValues({ ...values, [f.key]: e.target.value })} />
          ) : (
            <input value={values[f.key]} onChange={(e) => setValues({ ...values, [f.key]: e.target.value })} />
          )}
        </label>
      ))}
      <div className={styles.actions}>
        <Button size="sm" onClick={save} loading={busy}>Save and re-check</Button>
        <Button size="sm" variant="ghost" onClick={onCancel} disabled={busy}>Cancel</Button>
      </div>
    </div>
  );
};

export default EditPanel;
